import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { ApiResponse } from 'shared/interfaces/response'
import { Query } from "shared/types/query";
import { SubscriptionPurchaseRequestDTO } from "./dtos/subscription-purchase-request.dto";
import { EnterpriceContactRequestDTO } from "./dtos/enterprice-contact-request.dto";
import { Subscription } from "shared/models/subscriptions/subscription";
import { PurchaseSubscriptionRequestDTO } from "./dtos/purchase-subscription-request.dto";
import { PurchaseTrialedSubscriptionRequestDTO } from "./dtos/purchase-trialed-subscription-request.dto";

@Injectable()

export class SubscriptionsService{

    constructor(private http: HttpClient){}

    getSubscriptions(params: Query = {}){
        return this.http.get<ApiResponse<Subscription[]>>(`subscriptions`, { params }).pipe(
            map(resp => ({...resp, data: resp.data.map(i => new Subscription(i))}))
        )
    }

    getSubscriptionById(subscriptionId: string) {
        return this.http.get<ApiResponse<Subscription>>(`subscriptions/${subscriptionId}`).pipe(
            map(resp => ({...resp, data: new Subscription(resp.data)}))
        )
    }

    getSignupPlans(params: Query = {}) {
        return this.http.get<ApiResponse<Subscription[]>>(`subscriptions/plans`, { params }).pipe(
            map(resp => ({...resp, data: resp.data.map(i => new Subscription(i))}))
        )
    }

    purchaseSubscription(subscriptionId: string, body: PurchaseSubscriptionRequestDTO){
        return this.http.post<ApiResponse<SubscriptionPurchaseRequestDTO>>(`subscriptions/${subscriptionId}/purchase`, body).pipe(
            map((resp) => ({...resp, data: new SubscriptionPurchaseRequestDTO(resp.data)}))
        )
    }

    purchaseTrialedSubscription(body: PurchaseTrialedSubscriptionRequestDTO){
        return this.http.post<ApiResponse<SubscriptionPurchaseRequestDTO>>(`subscriptions/trial/checkout`, body).pipe(
            map((resp) => ({...resp, data: new SubscriptionPurchaseRequestDTO(resp.data)}))
        )
    }

    enterpriceContact(body: EnterpriceContactRequestDTO){
        return this.http.post<ApiResponse>(`enterprise-contact`, body).pipe(
            map(resp => resp)
        )
    }
}
